<template>
  <span v-if="instance">
    <v-row align="center" justify="center" class="fill-height fill-width fluid landing ma-0" :style="instanceBackground">
      <v-col cols="12" md="10" class="pa-0" style="max-width: 1000px">
        <v-card class="elevation-12 pa-6 ma-lg-12 ma-sm-2 ma-md-4 rounded-lg" rounded="0">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="7" lg="7">
                <span class="text-h4 ">
                  {{ instance.headline }}
                </span>
                <v-divider class=""></v-divider>
                <br />
                <div>
                  {{ instance.subtitle }}
                </div>
                <br />
                <a v-if="instance.learnMoreUrl" class=" text-h6" :href="instance.learnMoreUrl">Learn More</a>
              </v-col>
              <v-col cols="12" md="5" lg="5">
                <v-card class="elevation-0 pa-4 fill-height rounded" :style="$vuetify.display.md ? 'min-height:382px' : ''" rounded="0">
                  <v-card-title class="pt-0" style="height: 180px">
                    <failover-image v-if="instance.logo" :alt="instance.name" class="ma-auto" :src="instance.logo" :class="darkMode ? 'inverted-image' : ''" max-height="180px" />
                  </v-card-title>
                  <v-card-text>
                    <p class="text-h6 pb-6" :style="$vuetify.display.md ? 'min-height:120px' : ''">
                      {{ instance.ctaHeadline }}
                    </p>
                    <div align="center">
                      <v-btn id="get-started" color="primary" size="large" width="180" to="/register" variant="flat">Get
                        Started</v-btn>
                      <br />
                      <div class="ma-auto mt-6">
                        Already have an account?
                        <router-link to="/userlogin">Log In</router-link>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-footer v-if="instance" absolute class="font-weight-light">
      <v-col class="text-center" cols="12">© {{ new Date().getFullYear() }} — {{ instance.name }}</v-col>
    </v-footer>
  </span>
</template>
<script lang="js">
import { mapState, mapActions } from "vuex";
import { LOAD_INSTANCE_BY_ID } from "../../store/instances/mutation-types";

export default {
  name: 'Landing',
  props: { instanceID: String, preview: String },
  data: () => ({}),
  computed: {
    ...mapState('instances', ['instance', 'loading']),
    ...mapState('organization', ['organization']),
    instanceBackground: function () {
      let backgroundUrl = this.instance?.backgroundUrl ?? this.organization?.backgroundUrl ?? '';
      if (backgroundUrl.includes('http')) { backgroundUrl = `/api/proxy?url=${btoa(backgroundUrl)}`; }
      return { backgroundImage: `url("${backgroundUrl}")` };
    },
    darkMode() {
      return this.$vuetify.theme.dark || this.$vuetify.theme.name == "dark";
    }
  },
  methods: {
    ...mapActions('instances', [LOAD_INSTANCE_BY_ID]),
  }
};
</script>
<style scoped>
.landing {
  background: no-repeat center center;
  background-size: cover !important;
}

.v-footer {
  background-color: rgba(245, 245, 245, 0.6);
  overflow: hidden;
}

.v-application .grey.darken-3 {
  background-color: #424242d1 !important;
  border-color: #424242d1 !important;
}
</style>
